"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const fmko_ts_common_1 = require("fmko-ts-common");
const ImageWidget_1 = tslib_1.__importStar(require("./ImageWidget"));
class LoadingProgressWidget extends fmko_ts_common_1.Widget {
    constructor(args) {
        super();
        const { loadingMessage = "Indlæser data...", failedMessage = "Det fejlede at indlæse data!", successMessage = "Data indlæst" } = args ?? {};
        this.loadingMessage = loadingMessage;
        this.failedMessage = failedMessage;
        this.successMessage = successMessage;
        this.element = document.createElement("div");
        this.element.classList.add("loading-progress-widget");
        this.loadingContainer = document.createElement("div");
        this.loadingContainer.classList.add("loading-progress-loading-container");
        const spinnerIcon = new ImageWidget_1.default({
            alt: "Loading",
            imageDimension: ImageWidget_1.ImageDimensions.XL,
            src: fmko_ts_common_1.ImageSrcWithVersion.getImage(fmko_ts_common_1.ImageSrc.LIGHT_SPINNER_ANIMATED)
        });
        this.loadingContainer.appendChild(spinnerIcon.element);
        this.loadingTextSpan = document.createElement("span");
        this.loadingTextSpan.classList.add("loading-progress-loading-text");
        this.loadingTextSpan.setAttribute("role", fmko_ts_common_1.ARIARole.STATUS);
        this.loadingContainer.appendChild(this.loadingTextSpan);
        this.failedContainer = document.createElement("div");
        this.failedContainer.classList.add("loading-progress-failed-container");
        this.failedTextSpan = document.createElement("span");
        this.failedTextSpan.setAttribute("role", fmko_ts_common_1.ARIARole.ALERT);
        this.failedContainer.appendChild(this.failedTextSpan);
        this.add(this.loadingContainer);
        this.add(this.failedContainer);
        this.setStatus(fmko_ts_common_1.LoadingProgressStatus.IDLE);
    }
    setStatus(status) {
        this.status = status;
        const shouldDisplay = status === fmko_ts_common_1.LoadingProgressStatus.LOADING || status === fmko_ts_common_1.LoadingProgressStatus.ERROR;
        this.loadingContainer.classList.toggle("sr-only", status !== fmko_ts_common_1.LoadingProgressStatus.LOADING);
        this.failedContainer.classList.toggle("sr-only", status !== fmko_ts_common_1.LoadingProgressStatus.ERROR);
        this.setVisible(shouldDisplay);
        const nextLoadingMessage = status === fmko_ts_common_1.LoadingProgressStatus.LOADING ? this.loadingMessage : null;
        const nextSuccessMessage = status === fmko_ts_common_1.LoadingProgressStatus.SUCCESS ? this.successMessage : null;
        this.loadingTextSpan.textContent = nextLoadingMessage ?? nextSuccessMessage ?? "";
        const nextErrorMessage = status === fmko_ts_common_1.LoadingProgressStatus.ERROR ? this.failedMessage : null;
        this.failedTextSpan.textContent = nextErrorMessage ?? "";
    }
    setVisible(visible, retainPlacement = false) {
        // This ensures that the element is hidden but the messages are read correct by a screen-reader
        this.element.classList.toggle("sr-only", !visible);
    }
    getStatus() {
        return this.status;
    }
    setLoadingMessage(message) {
        this.loadingMessage = message;
    }
    setFailedMessage(message) {
        this.failedMessage = message;
    }
    setSuccessMessage(message) {
        this.successMessage = message;
    }
}
exports.default = LoadingProgressWidget;
//# sourceMappingURL=LoadingProgressWidget.js.map